import { camelCase, startCase } from "lodash";

export const pascalCase = (str) => startCase(camelCase(str)).replace(/ /g, "");

export const isNullOrEmpty = (str) => str === undefined || str === null || str === "" || str === "null";
